import { useSelector } from 'react-redux';
import { RealEstateFinancing } from './realEstateFinancing';
import { ReleasesINCC } from './releasesINCC';
import { ReleasesRealEstateFinancing } from './releasesRealEstateFinancing';
import { ReleasesVersusIPCA } from './releasesVersusIPCA';
import { SecondaryINCC } from './secondaryINCC';
import { SelicRate } from './selicRate';
import './marketCycleCharts.scss';

const MarketCycleCharts: React.FC = () => {
  const { isGridView } = useSelector((state: any) => state.chartsState);

  return (
    <div className={`market-cycle-charts ${isGridView ? '' : 'list-layout'}`}>
      <SelicRate />
      <ReleasesINCC />
      <SecondaryINCC />
      <ReleasesVersusIPCA />
      <ReleasesRealEstateFinancing />
      <RealEstateFinancing />
    </div>
  );
};

export default MarketCycleCharts;
